import { arePositionsEqual } from "./utils/are-positions-equal";

export * from "./models/azure-maps.models";
export * from "./services/capacitor-geolocation.service";
export * from "./services/device-orientation.service";
export * from "./services/geolocation.service";
export * from "./services/kml-exporter.service";
export * from "./shared-map.tokens";
export * from "./utils/weather-constants";

export const SharedMapUtils = {
    arePositionsEqual,
};
